<ng-container formGroupName="albuminTherapy">
  <app-service-data-form-condition-history
    [config]="{
      type: RadioFormType.Double,
      title: {
        question: 'serviceData.form.albuminTherapy.hasReceived' | translate,
        subQuestion: 'serviceData.form.albuminTherapy.isRelevant' | translate,
      },
      validationTranslation: {
        subAnswer: 'serviceData.form.validation.albuminTherapy',
      },
    }"
    [fieldSet]="fieldSet()"
    [field]="ServiceDataFields.HumanSerumAlbuminTherapy"
  />
</ng-container>

<ng-container formGroupName="cellularImmunotherapy">
  <app-service-data-form-condition-history
    [config]="{
      type: RadioFormType.Double,
      title: {
        question:
          'serviceData.form.cellularImmunotherapy.hasReceived' | translate,
        subQuestion:
          'serviceData.form.cellularImmunotherapy.isRelevant' | translate,
      },
      validationTranslation: {
        subAnswer: 'serviceData.form.validation.cellularImmunotherapy',
      },
    }"
    [fieldSet]="fieldSet()"
    [field]="ServiceDataFields.CellularImmunotherapy"
  />
</ng-container>

<ng-container formGroupName="stemCellTherapy">
  <app-service-data-form-condition-history
    [config]="{
      type: RadioFormType.Single,
      title: {
        question: 'serviceData.form.stemCellTherapy' | translate,
      },
      validationTranslation: {
        answer: 'serviceData.form.validation.stemCellTherapy',
      },
    }"
    [fieldSet]="fieldSet()"
    [field]="ServiceDataFields.StemCellTherapy"
  />
</ng-container>

<ng-container formGroupName="transplantSurgery">
  <app-service-data-form-condition-history
    [config]="{
      type: RadioFormType.Single,
      title: {
        question: 'serviceData.form.transplantSurgery' | translate,
      },
      validationTranslation: {
        answer: 'serviceData.form.validation.transplantSurgery',
      },
    }"
    [fieldSet]="fieldSet()"
    [field]="ServiceDataFields.TransplantSurgery"
  />
</ng-container>

<ng-container formGroupName="bloodTransfusion">
  <app-service-data-form-condition-history
    [config]="{
      type: RadioFormType.Double,
      title: {
        question: 'serviceData.form.bloodTransfusion.hasReceived' | translate,
        subQuestion: 'serviceData.form.bloodTransfusion.isRelevant' | translate,
      },
      validationTranslation: {
        subAnswer: 'serviceData.form.validation.bloodTransfusion',
      },
    }"
    [fieldSet]="fieldSet()"
    [field]="ServiceDataFields.BloodTransfusion"
  />
</ng-container>
